<div class="modal-header">
  <h4 class="modal-title">
    Edit {{ noteType === "Summary" ? "Summary" : "Note" }}
  </h4>
  <div class="ms-auto d-inline-flex align-items-center">
    @if (noteType === "Summary") {
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center me-2"
        (click)="pullFromNote()"
        [disabled]="!canPullFromNote()"
      >
        Pull from Note
      </button>
    }
    @if (shouldShowEpicActions()) {
      <span
        class="d-inline-flex align-items-center me-2"
        [ngbTooltip]="
          !isComprehensiveQuestionnaireCompleted
            ? 'Pending questionnaire completion by Donor candidate'
            : null
        "
        placement="top"
        container="body"
      >
        <button
          type="button"
          class="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
          (click)="generateNote()"
          [disabled]="
            isSaving || isGenerating || !isComprehensiveQuestionnaireCompleted
          "
        >
          <i class="bi bi-magic me-2" aria-hidden="true"></i>
          @if(!isGenerating){
            Generate Note
          } @else { 
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Generating...
          }
        </button>
      </span>
      <button
        type="button"
        class="btn btn-sm btn-outline-danger d-inline-flex align-items-center me-2"
        ngbTooltip="Feature unavailable on Epic Sandbox"
        placement="top"
        container="body"
        [disabled]="!editorContent || editorContent.trim().length === 0"
      >
        Push to Epic
      </button>
    }
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>
</div>
<div class="modal-body notes-modal-body">
  <div id="notes-toolbar" class="ql-toolbar ql-snow mb-2">
    <span class="ql-formats">
      <select class="ql-size" ngbTooltip="Font size" placement="top" container="body" aria-label="Font size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
    </span>
    <span class="ql-formats">
      <button class="ql-bold" ngbTooltip="Bold" placement="top" container="body" aria-label="Bold"></button>
      <button class="ql-italic" ngbTooltip="Italic" placement="top" container="body" aria-label="Italic"></button>
      <button class="ql-underline" ngbTooltip="Underline" placement="top" container="body" aria-label="Underline"></button>
      <button class="ql-strike" ngbTooltip="Strikethrough" placement="top" container="body" aria-label="Strikethrough"></button>
    </span>
    <span class="ql-formats" ngbDropdown>
      <!-- Color dropdown using ngbDropdown; items call the custom handler -->
      <button ngbDropdownToggle ngbTooltip="Text color" placement="top" container="body" aria-label="Text color">
        <i class="bi bi-palette" aria-hidden="true"></i>
      </button>
      <div ngbDropdownMenu class="p-1">
        <button class="ql-applyColor dropdown-item d-flex align-items-center" value="default">
          <span style="width:1rem;height:1rem;border:1px solid #dee2e6;border-radius:2px;margin-right:.5rem;display:inline-block;background:transparent"></span>
          Default
        </button>
        <button class="ql-applyColor dropdown-item d-flex align-items-center" value="#000000">
          <span style="width:1rem;height:1rem;border:1px solid #dee2e6;border-radius:2px;margin-right:.5rem;display:inline-block;background:#000000"></span>
          Black
        </button>
        <button class="ql-applyColor dropdown-item d-flex align-items-center" value="#008ad5">
          <span style="width:1rem;height:1rem;border:1px solid #dee2e6;border-radius:2px;margin-right:.5rem;display:inline-block;background:#008ad5"></span>
          Blue
        </button>
        <button class="ql-applyColor dropdown-item d-flex align-items-center" value="#dc3545">
          <span style="width:1rem;height:1rem;border:1px solid #dee2e6;border-radius:2px;margin-right:.5rem;display:inline-block;background:#dc3545"></span>
          Red
        </button>
        <button class="ql-applyColor dropdown-item d-flex align-items-center" value="#198754">
          <span style="width:1rem;height:1rem;border:1px solid #dee2e6;border-radius:2px;margin-right:.5rem;display:inline-block;background:#198754"></span>
          Green
        </button>
        <button class="ql-applyColor dropdown-item d-flex align-items-center" value="#6c757d">
          <span style="width:1rem;height:1rem;border:1px solid #dee2e6;border-radius:2px;margin-right:.5rem;display:inline-block;background:#6c757d"></span>
          Gray
        </button>
      </div>
    </span>
    <span class="ql-formats">
      <!-- Custom alignment buttons (Bootstrap Icons) -->
      <button class="ql-applyAlign" value="left" ngbTooltip="Align left" placement="top" container="body" aria-label="Align left">
        <i class="bi bi-text-left"></i>
      </button>
      <button class="ql-applyAlign" value="center" ngbTooltip="Align center" placement="top" container="body" aria-label="Align center">
        <i class="bi bi-text-center"></i>
      </button>
      <button class="ql-applyAlign" value="right" ngbTooltip="Align right" placement="top" container="body" aria-label="Align right">
        <i class="bi bi-text-right"></i>
      </button>
      <!-- Uncomment if your Bootstrap Icons version supports justify icon
      <button class="ql-applyAlign" value="justify" ngbTooltip="Justify" placement="top" container="body" aria-label="Justify">
        <i class="bi bi-justify"></i>
      </button> -->
    </span>
    <span class="ql-formats">
      <button class="ql-list" value="ordered" ngbTooltip="Numbered list" placement="top" container="body" aria-label="Numbered list"></button>
      <button class="ql-list" value="bullet" ngbTooltip="Bulleted list" placement="top" container="body" aria-label="Bulleted list"></button>
      <button class="ql-indent" value="-1" ngbTooltip="Decrease indent" placement="top" container="body" aria-label="Decrease indent"></button>
      <button class="ql-indent" value="+1" ngbTooltip="Increase indent" placement="top" container="body" aria-label="Increase indent"></button>
      <button class="ql-clean" ngbTooltip="Clear formatting" placement="top" container="body" aria-label="Clear formatting"></button>
    </span>
    <span class="ql-formats">
      <!-- Table controls with ngbTooltip -->
      <button class="ql-table" ngbTooltip="Insert table" placement="top" container="body" aria-label="Insert table">
        <i class="bi bi-table"></i>
      </button>
      <button class="ql-insertRowAbove" ngbTooltip="Insert row above" placement="top" container="body" aria-label="Insert row above">
        <i class="bi bi-arrow-bar-up"></i>
      </button>
      <button class="ql-insertRowBelow" ngbTooltip="Insert row below" placement="top" container="body" aria-label="Insert row below">
        <i class="bi bi-arrow-bar-down"></i>
      </button>
      <button class="ql-insertColumnLeft" ngbTooltip="Insert column left" placement="top" container="body" aria-label="Insert column left">
        <i class="bi bi-arrow-bar-left"></i>
      </button>
      <button class="ql-insertColumnRight" ngbTooltip="Insert column right" placement="top" container="body" aria-label="Insert column right">
        <i class="bi bi-arrow-bar-right"></i>
      </button>
      <button class="ql-deleteRow" ngbTooltip="Delete row" placement="top" container="body" aria-label="Delete row">
        <i class="bi bi-x-square"></i>
      </button>
      <button class="ql-deleteColumn" ngbTooltip="Delete column" placement="top" container="body" aria-label="Delete column">
        <i class="bi bi-x-square-fill"></i>
      </button>
      <button class="ql-deleteTable" ngbTooltip="Delete table" placement="top" container="body" aria-label="Delete table">
        <i class="bi bi-trash"></i>
      </button>
    </span>
  </div>
  <quill-editor
    class="editor"
    [(ngModel)]="editorContent"
    [modules]="quillModules"
    (onEditorCreated)="onEditorCreated($event)"
    [styles]="{ height: '100%'}"
  ></quill-editor>
</div>
<div class="modal-footer align-items-center">
  <div class="me-auto small text-muted d-flex align-items-center">
    @if (isAutoSaving) {
      <span class="d-inline-flex align-items-center">
        <span
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        Auto-saving...
      </span>
    } @else {
      @if (lastAutoSaveAt) {
        <span>Last auto-saved at: {{ lastAutoSaveAt | date: 'shortTime' }}</span>
      }
    }
  </div>
  <button
    type="button"
    class="btn btn-secondary"
    [disabled]="isSaving || isAutoSaving"
    (click)="close()"
  >
    Close
  </button>
  @if (isSaving) {
    <button [disabled]="isSaving" class="btn btn-primary">
      <i
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></i>
      Saving...
    </button>
  } @else {
    @if (isAutoSaving) {
      <button type="button" class="btn btn-primary" disabled>
        <span
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        Auto-saving...
      </button>
    } @else {
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="isAutoSaving"
        (click)="save()"
      >
        Save
      </button>
    }
  }
</div>
